export default __webpack_public_path__ + "static/media/twitter.7961c089.svg";